<template>
	
	<v-app>
		<v-card
			v-if="tokenResetPassword"
			width="1024"
			flat
			class="mx-auto my-auto pb-16">
			<v-container grid-list-md class="col-md-4 col-md-offset-6">
				<v-row
					cols="12"
					class="d-flex flex-column align-content-md-center mx-auto">
					<v-col cols="12">
						<router-link
							:to="{
								path: '/',
							}">
							<v-img
								class="mx-auto"
								src="/images/logo-black.svg"
								max-width="88">
							</v-img>
						</router-link>
					</v-col>
					<v-col class="text-center">
						<h6>
							<v-icon dense class="material-icons"
								>refresh</v-icon
							>
							
							Restablecer contraseña.
						</h6>
						<h6 class="d-inline-block text-truncate ml-n1">Ingrese los siguientes datos para continuar.</h6>
					</v-col>

					<v-col class="pa-md-0">
						<form
							@submit.prevent="resetPasswordToken"
							autocomplete="off">
							<v-text-field
								label="Correo electronico*"
                height="56"
                outlined
								required
								v-model="security.email"
								:rules="emailRules"></v-text-field>

							<v-text-field
								label="Contraseña"
								type="password"
                height="56"
                outlined
								required
								v-model="security.password_new"></v-text-field>

							<v-text-field
								label="Confirmar contraseña"
								type="password"
                height="56"
              outlined
								required
								v-model="
									security.password_confirmation
								"></v-text-field>

							<v-btn block rounded color="primary" height="44px" type="submit"
								>Restablecer contraseña
							</v-btn>
						</form>
					</v-col>
          <v-col cols="12" class="d-flex flex-column pa-md-0">
            <router-link :to="{ path: '/login' }">
            
              <v-btn
              class=" text-button mt-4"
              color="outline"
              height="44px"
              block
              rounded
                outlined
                
                >
                Iniciar Sesión
              </v-btn>
              </router-link>
            
          </v-col>
				</v-row>
			</v-container>
		</v-card>
		<div
			v-if="tokenResetPassword != null && !tokenResetPassword"
			class="animated fadeInUp">
			<v-container grid-list-md>
				<v-alert :value="true" type="error">
					<h2>
						Lo sentimos, no puedes restablecer tu contraseña...
						Parece que el token caducó o es incorrecto.
					</h2>
				</v-alert>
				<br />
				<br />
				<div class="text-center">
					<v-btn large @click="$router.push('/')">Ir al inicio</v-btn>
				</div>
			</v-container>
		</div>
	</v-app>
</template>
<script>
	export default {
		beforeRouteEnter(to, from, next) {
			next((vm) => {
				//vm.$store.dispatch('fetchAccessToken');
				if (vm.$store.state.user.accessToken != null) {
					next("/");
				}
			});
		},
		beforeCreate() {
			this.$store.dispatch(
				"findTokenPasswordReset",
				this.$route.params.token
			);
		},
		created() {
			document.title = "Restablecer contraseña - TicketShop";
		},
		data() {
			return {
				security: {
					email: null,
					password_new: null,
					password_confirmation: null,
					token: this.$route.params.token,
				},
				emailRules: [
					(v) =>
						/.+@.+/.test(v) ||
						"Direccion de correo electronico incorrecta",
				],
			};
		},
		methods: {
			resetPasswordToken() {
				if (
					this.security.password_new ==
					this.security.password_confirmation
				) {
					this.$store.dispatch("resetPasswordToken", this.security);
				} else {
					swal(
						"Error!",
						"Las contraseñas deben ser iguales!",
						"error"
					);
				}
			},
		},
		computed: {
			tokenResetPassword() {
				return this.$store.getters.tokenResetPassword;
			},
		},
	};
</script>
